class Customer.VisibleEvent extends Backbone.Model
 
  initialize: ->
    @set('sub_type', _.str.underscored(@get('event_type')) )

  created_at: ->
    return @get('event_date')

  ticketType: ->
    return 'visible_event'

  userCanModify: ->
    false

  uniqueId: ->
    'visible_event_' + @get('id')

class Customer.VisibleEventCollection extends Backbone.Collection
  model: Customer.VisibleEvent
  comparator: 'created_at'

  initialize: (models = null, options = {}) ->
    throw 'Error: cannot create a EventCollection without a conversation ID' unless options.conversation_id
    @conversation_id = options.conversation_id
    super
